module.exports = __webpack_public_path__ + "img/ok-icon1.5d60f99f.png";